// extracted by mini-css-extract-plugin
export var dropdown = "_t7-0";
export var imageWrapper = "_t7-3";
export var itemNameContainer = "_t7-1";
export var productImage = "_t7-2";
export var spinnerWrapper = "_t7-4";